export interface IContentPinned {
  contentId: string;
  pinPosition: number;
}
export class ContentToPin implements IContentPinned {
  constructor(
    public contentId: string,
    public pinPosition: number,
  ) {}
}
